import * as React from "react";
import { map } from "lodash";
import { Button, Alignment, Menu } from "@blueprintjs/core";
import { Select2 } from "@blueprintjs/select";
import { MenuItem2 } from "@blueprintjs/popover2";

import { Dimension } from "../../types/models";

interface IProps {
  onSelectDimension: (dimension: Dimension) => void;
  selectedDimension?: Dimension;
  disabled?: boolean;
  dimensionsByClientId: any[]
}

export class DimensionSelector extends React.Component<IProps> {
  private itemPredicate = (query: string, item: Dimension) => {
    const normalizedQuery = query.toLowerCase();
    return item.Name.toLowerCase().includes(normalizedQuery);
  };

  public render() {
    const { selectedDimension, disabled, dimensionsByClientId } = this.props;
    return (
      <Select2<Dimension>
        items={dimensionsByClientId}
        noResults={<MenuItem2 disabled={true} text="No dimensions found" />}
        itemListRenderer={(itemListProps) => (
          <Menu ulRef={itemListProps.itemsParentRef}>
            {map(itemListProps.items, (item, index) =>
              itemListProps.renderItem(item, index)
            )}
          </Menu>
        )}
        itemRenderer={(dimension, { modifiers, handleClick }) => (
          <MenuItem2
            active={modifiers.active}
            key={dimension.id}
            onClick={handleClick}
            text={dimension.Name}
            style={{ maxWidth: "250px", overflow: "hidden", textOverflow: "ellipsis" }}
        />
        )}
        itemPredicate={this.itemPredicate}
        onItemSelect={(dimension) =>
          this.props.onSelectDimension(dimension)
        }
        filterable={true}
        popoverProps={{ matchTargetWidth: true }}
        disabled={disabled}
      >
        <Button
          fill={true}
          alignText={Alignment.LEFT}
          rightIcon="caret-down"
          disabled={disabled}
          text={selectedDimension?.Name || "Select..."}
          style={{ minWidth: "200px", margin: '0 12px' }}
        />
      </Select2>
    );
  }
}
